import { apiUrl } from "../const";
import { doRetryOnTokenExpiration } from "../authSlice";
import doFetchFeeds from "./doFetchFeeds";

const doUploadOPML = (file, onResult): AppThunk => async (dispatch, getState) => {
  const formData = new FormData();
  formData.append("opml_file", file);
  try {
    const result = await doRetryOnTokenExpiration({
      method: "post",
      url: `${apiUrl}/opml`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }, dispatch, getState);
    if (result && result.data) {
      onResult(result.data);
      if (result.data.created > 0) {
        dispatch(doFetchFeeds());
      }
    } else {
      onResult({ error: "Upload failed" });
    }
  } catch (err) {
    onResult({ error: err.message || "Upload failed" });
  }
};

export default doUploadOPML;
